import { render, staticRenderFns } from "./AcknowledgeMessagesList.vue?vue&type=template&id=2fa285a2&"
import script from "./AcknowledgeMessagesList.vue?vue&type=script&lang=js&"
export * from "./AcknowledgeMessagesList.vue?vue&type=script&lang=js&"
import style0 from "./AcknowledgeMessagesList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports